export interface Message {
  text: string;
  identifier: string;
  persist?: boolean;
  penalty?: boolean;
}
